export const ORDER_DETAILS_CHANGE_TRACKING = {
  carrierBilling: {
    source: 'order_details.carrier_billing',
    id: 10003,
  },
  carrierOffers: {
    source: 'order_details.carrier_offers',
    id: 10034,
  },
  claim: {
    source: 'order_details.claim',
    id: 10010,
  },
  customerInformation: {
    source: 'order_details.customer_information',
    id: 10017,
  },
  customerPayments: {
    source: 'order_details.customer_payments',
    id: 10020,
  },
  documents: {
    source: 'order_details.documents',
    id: 10022,
  },
  ediUpdates: {
    source: 'order_details.edi_updates',
    id: 10023,
  },
  internalNotes: {
    source: 'order_details.internal_notes',
    id: 10019,
  },
  loadDetails: {
    source: 'order_details.load_details',
    id: 10025,
  },
  orderHeader: {
    source: 'order_details.order_header',
    id: 10036,
  },
  orderCreate: {
    source: 'order_details.create_order',
    id: 10037,
  },
  pointOfSale: {
    source: 'order_details.point_of_sale',
    id: 10039,
  },
  stops: {
    source: 'order_details.stops',
    id: 10043,
  },
  tracking: {
    source: 'order_details.tracking',
    id: 10044,
  },
  vendorCosts: {
    source: 'order_details.vendor_costs',
    id: 10046,
  },
  vendorDetails: {
    source: 'order_details.vendor_details',
    id: 10045,
  },
  vendorPayments: {
    source: 'order_details.vendor_payments',
    id: 10047,
  },
  carrierBillingRequestCheck: {
    source: 'order_details.carrier_billing.request_check',
    id: 10145,
  },
  carrierBillingVoidCheck: {
    source: 'order_details.carrier_billing.void_check',
    id: 10159,
  },
  carrierOffersApproveCounter: {
    source: 'order_details.carrier_offers.approve_counter',
    id: 10152,
  },
  carrierOffersApproveOffer: {
    source: 'order_details.carrier_offers.approve_offer',
    id: 10156,
  },
  carrierOffersBookLoad: {
    source: 'order_details.carrier_offers.book_load',
    id: 10158,
  },
  carrierOffersCounterOffer: {
    source: 'order_details.carrier_offers.counter_offer',
    id: 10155,
  },
  carrierOffersEditBid: {
    source: 'order_details.carrier_offers.edit_bid',
    id: 10157,
  },
  carrierOffersExpireBid: {
    source: 'order_details.carrier_offers.expire_bid',
    id: 10153,
  },
  carrierOffersRejectOffer: {
    source: 'order_details.carrier_offers.reject_offer',
    id: 10154,
  },
  carrierOffersSubmitBid: {
    source: 'order_details.carrier_offers.submit_bid',
    id: 10151,
  },
  customerPaymentsSendCreditCardPayment: {
    source: 'order_details.customer_payments.send_credit_card_payment',
    id: 10140,
  },
  documentsDelete: {
    source: 'order_details.documents.delete',
    id: 10101,
  },
  documentsUpload: {
    source: 'order_details.documents.upload',
    id: 10102,
  },
  ediUpdatesResend: {
    source: 'order_details.edi_updates.resend',
    id: 10142,
  },
  ediUpdatesSendUpdate: {
    source: 'order_details.edi_updates.send_update',
    id: 10147,
  },
  ediUpdatesUnlinkTender: {
    source: 'order_details.edi_updates.unlink_tender',
    id: 10144,
  },
  loadDetailsCarrierContact: {
    source: 'order_details.load_details.carrier_contact',
    id: 10103,
  },
  loadDetailsCarrierRating: {
    source: 'order_details.load_details.carrier_rating',
    id: 10104,
  },
  loadDetailsBlacklist: {
    source: 'order_details.load_details.blacklist',
    id: 10168,
  },
  loadDetailsBounceCarrier: {
    source: 'order_details.load_details.bounce_carrier',
    id: 10170,
  },
  loadDetailsDispatch: {
    source: 'order_details.load_details.dispatch',
    id: 10105,
  },
  loadDetailsSubmitPickupRequest: {
    source: 'order_details.load_details.submit_pickup_request',
    id: 10149,
  },
  loadDetailsFallout: {
    source: 'order_details.load_details.fallout',
    id: 10106,
  },
  loadDetailsFlagAddComment: {
    source: 'order_details.load_details.flag.add_comment',
    id: 10132,
  },
  loadDetailsFlagCreate: {
    source: 'order_details.load_details.flag.create',
    id: 10112,
  },
  loadDetailsFlagDelete: {
    source: 'order_details.load_details.flag.delete',
    id: 10131,
  },
  loadDetailsFlagDeleteComment: {
    source: 'order_details.load_details.flag.delete_comment',
    id: 10133,
  },
  loadDetailsFlagDispute: {
    source: 'order_details.load_details.flag.dispute',
    id: 10134,
  },
  loadDetailsFlagUpdate: {
    source: 'order_details.load_details.flag.update',
    id: 10130,
  },
  loadDetailsInsurance: {
    source: 'order_details.load_details.insurance',
    id: 10107,
  },
  loadDetailsPlaylist: {
    source: 'order_details.load_details.playlist',
    id: 10113,
  },
  loadDetailsPostLoad: {
    source: 'order_details.load_details.post_load',
    id: 10108,
  },
  loadDetailsRateCon: {
    source: 'order_details.load_details.rate_con',
    id: 10109,
  },
  loadDetailsRequestPickup: {
    source: 'order_details.load_details.request_pickup',
    id: 10150,
  },
  loadDetailsGetLtlRates: {
    source: 'order_details.load_details.get_ltl_rates',
    id: 10167,
  },
  loadDetailsRequote: {
    source: 'order_details.load_details.requote',
    id: 10110,
  },
  loadDetailsRequestReactivation: {
    source: 'order_details.load_details.request_reactivation',
    id: 10169,
  },
  loadDetailsShareCapacity: {
    source: 'order_details.load_details.share_capacity',
    id: 10111,
  },
  loadDetailsStatus: {
    source: 'order_details.load_details.status',
    id: 10124,
  },
  loadDetailsVoidLoad: {
    source: 'order_details.load_details.void_load',
    id: 10125,
  },
  orderHeaderCopyOrder: {
    source: 'order_details.order_header.copy_order',
    id: 10114,
  },
  orderHeaderDeleteTemplate: {
    source: 'order_details.order_header.delete_template',
    id: 10129,
  },
  orderHeaderFlagAddComment: {
    source: 'order_details.order_header.flag.add_comment',
    id: 10137,
  },
  orderHeaderFlagCreate: {
    source: 'order_details.order_header.flag.create',
    id: 10115,
  },
  orderHeaderFlagDelete: {
    source: 'order_details.order_header.flag.delete',
    id: 10136,
  },
  orderHeaderFlagDeleteComment: {
    source: 'order_details.order_header.flag.delete_comment',
    id: 10138,
  },
  orderHeaderFlagDispute: {
    source: 'order_details.order_header.flag.dispute',
    id: 10139,
  },
  orderHeaderFlagUpdate: {
    source: 'order_details.order_header.flag.update',
    id: 10135,
  },
  orderHeaderLockLoad: {
    source: 'order_details.order_header.lock_load',
    id: 10126,
  },
  orderHeaderRefreshLock: {
    source: 'order_details.order_header.refresh_lock',
    id: 10128,
  },
  orderHeaderSaveTemplate: {
    source: 'order_details.order_header.save_template',
    id: 10116,
  },
  orderHeaderUnlockLoad: {
    source: 'order_details.order_header.unlock_load',
    id: 10127,
  },
  orderHeaderVoidOrder: {
    source: 'order_details.order_header.void_order',
    id: 10117,
  },
  stopsAddToAddressBook: {
    source: 'order_details.stops.add_to_address_book',
    id: 10162,
  },
  stopsDisableTracking: {
    source: 'order_details.stops.disable_tracking',
    id: 10163,
  },
  stopsResendTrackingInstallation: {
    source: 'order_details.stops.resend_tracking_installation',
    id: 10164,
  },
  stopsSaveLtlCatalog: {
    source: 'order_details.stops.save_ltl_catalog',
    id: 10141,
  },
  stopsSetAppointmentReminder: {
    source: 'order_details.stops.set_appointment_reminder',
    id: 10148,
  },
  stopsUpdateDriverInOutTimes: {
    source: 'order_details.stops.update_driver_in_out_times',
    id: 10161,
  },
  trackingAddComment: {
    source: 'order_details.tracking.add_comment',
    id: 10118,
  },
  trackingDeleteComment: {
    source: 'order_details.tracking.delete_comment',
    id: 10119,
  },
  trackingDisableTracking: {
    source: 'order_details.tracking.disable_tracking',
    id: 10120,
  },
  trackingLoadStatus: {
    source: 'order_details.tracking.load_status',
    id: 10166,
  },
  trackingResendTrackingInstallation: {
    source: 'order_details.tracking.resend_tracking_installation',
    id: 10165,
  },
  trackingScheduleCheckCall: {
    source: 'order_details.tracking.schedule_check_call',
    id: 10121,
  },
  trackingSendCustomerUpdate: {
    source: 'order_details.tracking.send_customer_update',
    id: 10122,
  },
  trackingUpdateVisibility: {
    source: 'order_details.tracking.update_visibility',
    id: 10123,
  },
  vendorDetailsVoidVendor: {
    source: 'order_details.vendor_details.void_vendor',
    id: 10143,
  },
  vendorPaymentsRequestCheck: {
    source: 'order_details.vendor_payments.request_check',
    id: 10146,
  },
  vendorPaymentsVoidCheck: {
    source: 'order_details.vendor_payments.void_check',
    id: 10160,
  },
  // Datadog-only: tags product feedback, never sent as a change-source header.
  orderDetailsPageFeedback: {
    source: 'order_details.page_feedback',
    id: 10900,
  },
} as const;
